/* Body-Toogle für CSS-Manipulation */ 
/************************************/
function toggleBody(className) {
	var body = document.body;
	if (body.classList.contains(className)) {
		body.classList.remove(className);
	} else {
		body.classList.add(className);
	}
}

/* Blaufilter-Regel */
/********************/
function changeBluescale(value) {
	Cookies.set('acc_bluescale', value);
	var elementToChange = document.getElementById("shader-bluefilter");
	var transparencyValue = value / 10;
	if (transparencyValue === 0) {
		elementToChange.style.display = "none";
	} else if (transparencyValue >= 0.1 && transparencyValue <= 1.0) {
		elementToChange.style.display = "block";
	}
	elementToChange.style.backgroundColor = "rgba(245, 168, 93, " + transparencyValue + ")";
}
function resetBluescale(){
	var elementToChange = document.getElementById("shader-bluefilter");
	elementToChange.style.display = "none";
	Cookies.remove('acc_bluescale');
	var bluefilterSlider = document.getElementById('bluefilterAcc');
	bluefilterSlider.value = 0;
}

/* Greyscale-Regel */
/*******************/
function changeGreyscale(value) {
	Cookies.set('acc_greyscale', value);
	var elementToChange = document.getElementById("shader-greyscale");
	var transparencyValue = value;
	if (value === 0) {
		elementToChange.style.display = "none";
	} else if (value >= 0.05 && value <= 1.0) {
		elementToChange.style.display = "block";
	}
	elementToChange.style.backgroundColor = "rgba(0, 0, 0, " + value + ")";
}
function resetGreyscale(){
	var elementToChange = document.getElementById("shader-greyscale");
	elementToChange.style.display = "none";
	Cookies.remove('acc_greyscale');
	var greyscaleSlider = document.getElementById('greyscaleAcc');
	greyscaleSlider.value = 0;
}

/* Saturation-Regel */
/********************/
function changeSaturation(value) {
	Cookies.set('acc_saturation', value);
	var elementToChange = document.getElementById("shader-saturation");
	var transparencyValue = value / 10;
	if (value === 0) {
		elementToChange.style.display = "none";
	} else if (value >= 0.05 && value <= 1.0) {
		elementToChange.style.display = "block";
	}
	elementToChange.style.backgroundColor = "rgba(0, 256, 0, " + value + ")";
}
function resetSaturation(){
	var elementToChange = document.getElementById("shader-saturation");
	elementToChange.style.display = "none";
	Cookies.remove('acc_saturation');
	var saturationSlider = document.getElementById('saturationAcc');
	saturationSlider.value = 0;
}

/* Kontrast einstellen */
/***********************/
function changeContrast(value) {
	Cookies.set('acc_contrast', value);
	var contrastValue = parseFloat(value);
	var main = document.querySelector("#main");
  	main.style.setProperty('filter', 'contrast(' + contrastValue + ')');
}
function resetContrast(){
	var contrastValue = 0;
	var main = document.querySelector("#main");
  	main.style.removeProperty('filter');
  	Cookies.remove('acc_contrast');
	var contrastSlider = document.getElementById('contrastAcc');
	contrastSlider.value = 0;
}

/* Fontsize-Change */
/*******************/
function changeFontsize(size) {
	Cookies.set('acc_fontsize', size);
	const selector = 'p, ul, li, span, a, small, h1, h2, h3, h4, h5, h6';
	const all = Array.from(document.querySelectorAll(selector));
	all.forEach(el => {
		if (el.closest('.excludeAcc')) return;
		const childHasMatch = Array.from(el.querySelectorAll(selector))
			.some(child => child !== el && !child.closest('.excludeAcc'));
		if (!childHasMatch) {
			let factor = 1.0;
			const tag = el.tagName.toUpperCase();
			const scaleFactors = {
				H1: 2.0,
				H2: 1.75,
				H3: 1.5,
				H4: 1.25,
				H5: 1.1,
				H6: 1.0
			};
			if (scaleFactors[tag]) factor = scaleFactors[tag];
			if (size === 1.0) {
				el.style.removeProperty('font-size');
			} else {
				el.style.setProperty('font-size', (size * factor) + "em", 'important');
			}
		}
	});
}
function resetFontsize() {
	const selector = 'p, ul, li, span, a, small, h1, h2, h3, h4, h5, h6';
	const all = Array.from(document.querySelectorAll(selector));
	all.forEach(el => {
		if (el.closest('.excludeAcc')) return;
		const childHasMatch = Array.from(el.querySelectorAll(selector))
			.some(child => child !== el && !child.closest('.excludeAcc'));
		if (!childHasMatch) {
			el.style.removeProperty('font-size');
		}
	});
	Cookies.remove('acc_fontsize');
	const fontsizeSlider = document.getElementById('fontsizeAcc');
	if (fontsizeSlider) fontsizeSlider.value = 1.0;
	changeFontsize(1.0);
}

/* Linespacing-Change */
/*******************/
function changeLinespacing(size){
	Cookies.set('acc_linespacing', size);
	const textElementsP = document.querySelectorAll('p');
	textElementsP.forEach(textElement => {
    	textElement.style.lineHeight = size + "em";
  	});
  	const textElementsUl = document.querySelectorAll('ul');
	textElementsUl.forEach(textElement => {
    	textElement.style.lineHeight = size + "em";
  	});
	const newH1 = size * 0.8;
	const textElementsH1 = document.querySelectorAll('h1');
	textElementsH1.forEach(textElement => {
    	textElement.style.lineHeight = newH1 + "em";
  	});
  	const newH2 = size * 0.8;
	const textElementsH2 = document.querySelectorAll('h2');
	textElementsH2.forEach(textElement => {
    	textElement.style.lineHeight = newH2 + "em";
  	});
  	const newH3 = size * 1;
	const textElementsH3 = document.querySelectorAll('h3');
	textElementsH3.forEach(textElement => {
    	textElement.style.lineHeight = newH3 + "em";
  	});
  	const newH4 = size * 1;
	const textElementsH4 = document.querySelectorAll('h4');
	textElementsH4.forEach(textElement => {
    	textElement.style.lineHeight = newH4 + "em";
  	});
}
function resetLinespacing(){
	var size = 1.5;
	const textElementsP = document.querySelectorAll('p');
	textElementsP.forEach(textElement => {
		textElement.removeAttribute('style');
  	});
  	const textElementsUl = document.querySelectorAll('ul');
	textElementsUl.forEach(textElement => {
    	textElement.style.lineHeight = size + "em";
  	});
	const newH1 = 1.2;
	const textElementsH1 = document.querySelectorAll('h1');
	textElementsH1.forEach(textElement => {
		textElement.removeAttribute('style');
  	});
  	const newH2 = 1.2;
	const textElementsH2 = document.querySelectorAll('h2');
	textElementsH2.forEach(textElement => {
    	textElement.removeAttribute('style');
  	});
  	const newH3 = 1.5;
	const textElementsH3 = document.querySelectorAll('h3');
	textElementsH3.forEach(textElement => {
    	textElement.removeAttribute('style');
  	});
  	const newH4 = 1.5;
	const textElementsH4 = document.querySelectorAll('h4');
	textElementsH4.forEach(textElement => {
    	textElement.removeAttribute('style');
  	});
  	Cookies.remove('acc_linespacing');
	var linespacingSlider = document.getElementById('linespacingAcc');
	linespacingSlider.value = 1.5; 
}

/* Vorlesefunktion */
/*******************/
function readSelectedText() {
	var selectedText = getSelectedText();
	if (selectedText) {
		speakText(selectedText);
	}
}
function getSelectedText() {
	var text = "";
	if (typeof window.getSelection !== "undefined") {
		text = window.getSelection().toString();
	} else if (typeof document.selection !== "undefined" && document.selection.type === "Text") {
		text = document.selection.createRange().text;
	}
	return text.trim();
}
function speakText(text) {
	var utterance = new SpeechSynthesisUtterance(text);
	speechSynthesis.speak(utterance);
}
function stopSelectedText() {
  	speechSynthesis.cancel();
}

/* Lichtbar einblenden */
/***********************/
function showLightbar(){
	var button = document.getElementById('lightbarAcc');
	var lightbartop = document.getElementById('light-bar-top');
	var lightbarbottom = document.getElementById('light-bar-bottom');
	if (button.innerHTML === '<i class="fa-solid fa-highlighter pe-2"></i>Lichtbalken einblenden') {
		button.innerHTML = '<i class="fa-solid fa-highlighter pe-2" ></i>Lichtbalken ausblenden';
		lightbartop.style.display = 'block';
		lightbarbottom.style.display = 'block';
		Cookies.set('acc_lightbar', 'true');
	} else {
		button.innerHTML = '<i class="fa-solid fa-highlighter pe-2" ></i>Lichtbalken einblenden';
		lightbartop.style.display = 'none';
		lightbarbottom.style.display = 'none';
		Cookies.set('acc_lightbar', 'false');
	}
}
function resetLightbar(){
	var button = document.getElementById('lightbarAcc');
	var lightbartop = document.getElementById('light-bar-top');
	var lightbarbottom = document.getElementById('light-bar-bottom');
	button.innerHTML = '<i class="fa-solid fa-highlighter pe-2" ></i>Lichtbalken einblenden';
	lightbartop.style.display = 'none';
	lightbarbottom.style.display = 'none';
	Cookies.remove('acc_lightbar');
}
function updatePositionDisplay(event) {
	var lightbartop = document.getElementById('light-bar-top');
	var lightbarbottom = document.getElementById('light-bar-bottom');
	var mouseYBtm = window.innerHeight - event.clientY;
	var mouseYTop = event.clientY;
	var offsetYBtm = mouseYBtm - 100;
	var offsetYTop = mouseYTop - 100;
	lightbarbottom.style.height = offsetYBtm + 'px';
	lightbartop.style.height = offsetYTop + 'px';
}
window.addEventListener('mousemove', updatePositionDisplay);

/* Dark Mode */
/*************/
/* function toggleDarkMode() {
	var body = document.body;
	body.classList.toggle('dark-mode');
	changeImages();
	if (body.classList.contains('dark-mode')) {
		Cookies.set('acc_darkmode', 'true');
  	} else {
  		Cookies.set('acc_darkmode', 'false');
  	}
} 
function changeImages(){
	var body = document.body;
	var imgElement1 = document.getElementById('headlogo');
	var imgElement2 = document.getElementById('bike_icon');
	var imgElement3 = document.getElementById('hike_icon');
	var imgElements4 = document.getElementsByClassName('clock_icon');
	var imgElements5 = document.getElementsByClassName('lenght_icon');
	if (body.classList.contains('dark-mode')) {
		if(imgElement1){
			imgElement1.src = '/wp-content/themes/obermainjura/assets/img/svg/omj_logo-white.svg';
		}
		if(imgElement2){
			imgElement2.src = '/wp-content/themes/obermainjura/assets/img/svg/bike_white.svg';
		}
		if(imgElement3){
			imgElement3.src = '/wp-content/themes/obermainjura/assets/img/svg/hike_white.svg';	
		}
		if(imgElements4){
			for (var i = 0; i < imgElements4.length; i++) {
				var image = imgElements4[i];
				image.src = '/wp-content/themes/obermainjura/assets/img/svg/clock_white.svg';	
			}
		}
		if(imgElements5){
			for (var i = 0; i < imgElements5.length; i++) {
				var image = imgElements5[i];
				image.src = '/wp-content/themes/obermainjura/assets/img/svg/length_white.svg';	
			}
		}
	} else {
		if(imgElement1){
			imgElement1.src = '/wp-content/themes/obermainjura/assets/img/svg/omj_logo.svg';	
		}
		if(imgElement2){
			imgElement2.src = '/wp-content/themes/obermainjura/assets/img/svg/bike.svg';	
		}
		if(imgElement3){
			imgElement3.src = '/wp-content/themes/obermainjura/assets/img/svg/hike.svg';	
		}
		if(imgElements4){
			for (var i = 0; i < imgElements4.length; i++) {
				var image = imgElements4[i];
				image.src = '/wp-content/themes/obermainjura/assets/img/svg/clock.svg';	
			}
		}
		if(imgElements5){
			for (var i = 0; i < imgElements5.length; i++) {
				var image = imgElements5[i];
				image.src = '/wp-content/themes/obermainjura/assets/img/svg/length.svg';	
			}
		}
	}
}
function resetDarkmode(){
	var body = document.body;
	if (body.classList.contains('dark-mode')) {
		body.classList.toggle('dark-mode');
		changeImages();
  	} 
  	Cookies.remove('acc_darkmode');
}
document.addEventListener('DOMContentLoaded', function() {
	var images = document.querySelectorAll('img');
	images.forEach(function(image) {
		var imageSource = image.src;
		if (imageSource.toLowerCase().endsWith('.png')) {
			image.classList.add('png-image');
		} else if (imageSource.toLowerCase().endsWith('.jpeg') || imageSource.toLowerCase().endsWith('.jpg')) {
			image.classList.add('jpeg-image');
		}
	});
	changeImages();
}); */

/* Bilder ausblenden */
/*********************/
function toggleImages() {
	var elements = document.getElementsByTagName('*');
	for (var i = 0; i < elements.length; i++) {
		var element = elements[i];
		var backgroundImage = window.getComputedStyle(element).backgroundImage;
		if (element.tagName === 'IMG') {
			if (element.classList.contains('activeNoPicFilter')){
				if (element.dataset.srcValue) {
    				element.setAttribute('src', element.dataset.srcValue);
    				delete element.dataset.srcValue;
    				element.classList.remove('activeNoPicFilter');
  				}
			} else {
				var srcValue = element.getAttribute('src');
				element.dataset.srcValue = srcValue;
				element.removeAttribute('src');
				element.classList.add('activeNoPicFilter');
			}
		} else {
			if (backgroundImage !== 'none') {
				if (!element.classList.contains('has-background-image')){
					element.classList.add('has-background-image');
					element.classList.add('activeNoPicFilter');
				}
			} else {
				if (element.classList.contains('activeNoPicFilter')){
					element.classList.remove('has-background-image');
					element.classList.remove('activeNoPicFilter');
				}
			}
		}
	}
	var button = document.getElementById('nopicAcc');
	if (button.innerHTML === '<i class="fa-solid fa-image pe-2"></i>Bilder ausblenden') {
		button.innerHTML = '<i class="fa-solid fa-image pe-2"></i>Bilder einblenden';
		Cookies.set('acc_toggleImages', 'true');
	} else {
		button.innerHTML = '<i class="fa-solid fa-image pe-2"></i>Bilder ausblenden';
		Cookies.set('acc_toggleImages', 'false');
	}
}

/* Turn off Animation */
/**********************/
/* function toggleAnimation(){
	var elements = document.getElementsByTagName('*');
	var button = document.getElementById('animationAcc');
	if (button.innerHTML === '<i class="fa-solid fa-film pe-2"></i>Animationen ausschalten') {
		for (var i = 0; i < elements.length; i++) {
			var element = elements[i];
			if (element.classList.contains('reveal')){
				var originalClass = element.getAttribute('data-original-class');
				if (!originalClass) {
					element.setAttribute('data-original-class', element.classList);
				}
				element.classList.remove('reveal');	
			}
		}
		button.innerHTML = '<i class="fa-solid fa-film pe-2"></i>Animationen einschalten';
		Cookies.set('acc_animation', 'true');
	} else {
		for (var i = 0; i < elements.length; i++) {
			var element = elements[i];
			var originalClass = element.getAttribute('data-original-class');
			if (originalClass && originalClass.includes("reveal")) {
				element.className = originalClass;
				element.removeAttribute('data-original-class');
			}
		}
		button.innerHTML = '<i class="fa-solid fa-film pe-2"></i>Animationen ausschalten';
		Cookies.set('acc_animation', 'false');
	}
	var fogs = document.getElementsByClassName('fog-bg');
	for (var i = 0; i < fogs.length; i++) {
		var element = fogs[i];
		if (element.style.display === 'none') {
			element.style.display = 'block';
		} else {
			element.style.display = 'none';
		}
	}
	var bounces = document.getElementsByClassName('omj-cta');
	for (var i = 0; i < bounces.length; i++) {
		var element = bounces[i];
		if (element.classList.contains('no-animate')){
			element.classList.remove('no-animate');	
		} else {
			element.classList.add('no-animate');	
		}
	}
	var animation = document.getElementsByClassName('covercontainer');
	for (var i = 0; i < animation.length; i++) {
		var element = animation[i];
		if (element.classList.contains('no-animate')){
			element.classList.remove('no-animate');	
		} else {
			element.classList.add('no-animate');	
		}
	}
	var vline = document.getElementsByClassName('vertical-line');
	for (var i = 0; i < vline.length; i++) {
		var element = vline[i];
		if (element.classList.contains('no-animate')){
			element.classList.remove('no-animate');	
		} else {
			element.classList.add('no-animate');	
		}
	}
}
function resetAnimation(){
	Cookies.remove('acc_animation');
	var elements = document.getElementsByTagName('*');
	var button = document.getElementById('animationAcc');
	for (var i = 0; i < elements.length; i++) {
		var element = elements[i];
		var originalClass = element.getAttribute('data-original-class');
		if (originalClass && originalClass.includes("reveal")) {
			element.className = originalClass;
			element.removeAttribute('data-original-class');
		}
	}
	button.innerHTML = '<i class="fa-solid fa-film pe-2"></i>Animationen ausschalten';
	var fogs = document.getElementsByClassName('fog-bg');
	for (var i = 0; i < fogs.length; i++) {
		var element = fogs[i];
		element.style.display = 'none';
	}
	var bounces = document.getElementsByClassName('omj-cta');
	for (var i = 0; i < bounces.length; i++) {
		var element = bounces[i];
		element.classList.remove('no-animate');
	}
	var animation = document.getElementsByClassName('covercontainer');
	for (var i = 0; i < animation.length; i++) {
		var element = animation[i];
		element.classList.remove('no-animate');	
	}
	var vline = document.getElementsByClassName('vertical-line');
	for (var i = 0; i < vline.length; i++) {
		var element = vline[i];
		element.classList.remove('no-animate');	
	}
} */

/* Farbschwächen-Modi */
/**********************/
function toggleProtanomaly() {
	var main = document.querySelector("#main");
  	main.classList.remove('deuteranomaly');
  	main.classList.remove('tritanomaly');
  	main.style.removeProperty('filter');
  	main.classList.toggle('protanomaly');
	if (main.classList.contains('protanomaly')) {
		Cookies.set('acc_colorweakness', 'protanomaly');
  	} else {
  		Cookies.remove('acc_colorweakness');
  	}
}
function toggleDeuteranomaly() {
	var main = document.querySelector("#main");
  	main.classList.remove('protanomaly');
  	main.classList.remove('tritanomaly');
  	main.style.removeProperty('filter');
  	main.classList.toggle('deuteranomaly');
  	if (main.classList.contains('deuteranomaly')) {
		Cookies.set('acc_colorweakness', 'deuteranomaly');
  	} else {
  		Cookies.remove('acc_colorweakness');
  	}
}
function toggleTritanomaly() {
	var main = document.querySelector("#main");
  	main.classList.remove('protanomaly');
  	main.classList.remove('deuteranomaly');
  	main.style.removeProperty('filter');
  	main.classList.toggle('tritanomaly');
  	if (main.classList.contains('tritanomaly')) {
		Cookies.set('acc_colorweakness', 'tritanomaly');
  	} else {
  		Cookies.remove('acc_colorweakness');
  	}
}
function resetColorWeakness(){
	Cookies.remove('acc_colorweakness');
	var main = document.querySelector("#main");
  	main.classList.remove('protanomaly');
  	main.classList.remove('deuteranomaly');
  	main.classList.remove('tritanomaly');
}

/* Lade- und Übertragsfunktion */
/*******************************/
document.addEventListener("DOMContentLoaded", function(event){
	var darkmode = Cookies.get('acc_darkmode');
	if(darkmode && darkmode === 'true'){
		toggleDarkMode();
		changeImages();
	} 
	var bluescale = Cookies.get('acc_bluescale');
	if(bluescale && bluescale.length > 0){
		changeBluescale(bluescale);
		var sliderBluescale = document.getElementById('bluefilterAcc');
		sliderBluescale.value = bluescale;
	}
	var togglePics = Cookies.get('acc_toggleImages');
	if(togglePics && togglePics === 'true'){
		toggleImages();
	}
	var lightbar = Cookies.get('acc_lightbar');
	if(lightbar && lightbar === 'true'){
		showLightbar();
	}
	var toggleAnim = Cookies.get('acc_animation');
	if(toggleAnim && toggleAnim === 'true'){
		toggleAnimation();
	}
	var greyscale = Cookies.get('acc_greyscale');
	if(greyscale && greyscale.length > 0){
		changeGreyscale(greyscale);
		var sliderGreyscale = document.getElementById('greyscaleAcc');
		sliderGreyscale.value = greyscale;
	}
	var contrast = Cookies.get('acc_contrast');
	if(contrast && contrast.length > 0){
		changeContrast(contrast);
		var sliderContrast = document.getElementById('contrastAcc');
		sliderContrast.value = contrast;
	}
	var saturation = Cookies.get('acc_saturation');
	if(saturation && saturation.length > 0){
		changeSaturation(saturation);
		var sliderSaturation = document.getElementById('saturationAcc');
		sliderSaturation.value = saturation;
	}
	var colorweakness = Cookies.get('acc_colorweakness');
	if(colorweakness && colorweakness === 'protanomaly'){
		toggleProtanomaly();
	} else if(colorweakness && colorweakness === 'deuteranomaly'){
		toggleDeuteranomaly();
	} else if(colorweakness && colorweakness === 'tritanomaly'){
		toggleTritanomaly();
	}
	var fontsize = Cookies.get('acc_fontsize');
	if(fontsize && fontsize.length > 0){
		changeFontsize(fontsize);
		var sliderFontsize = document.getElementById('fontsizeAcc');
		sliderFontsize.value = fontsize;
	}
	var linespacing = Cookies.get('acc_linespacing');
	if(linespacing && linespacing.length > 0){
		changeLinespacing(linespacing);
		var sliderLinespacing = document.getElementById('linespacingAcc');
		sliderLinespacing.value = fontsize;
	}
});

/* Zurücksetzen */
/****************/
function resetAcc(){
	resetBluescale();
	resetGreyscale();
	resetSaturation();
	resetContrast();
	resetFontsize();
	resetLinespacing();
	resetLightbar();
	// resetDarkmode();
	resetColorWeakness();	
	// resetAnimation();
}